module.exports = __webpack_public_path__ + "static/media/lattes.ef936e28.png";